module.exports = __webpack_public_path__ + "r-v3/img/img_progress1.76b8f420.svg";